export const EqualDebtTypes = {
  SHOW_APARTMENT_EQUAL_DEBT: 'SHOW_APARTMENT_EQUAL_DEBT',
  ADD_EQUAL_DEBT: 'ADD_EQUAL_DEBT',
}
